import * as crypto from 'crypto-js';

/**
 * Nonce
 */
export class Nonce {

  /**
   * Adds nonce to given object
   *
   * @param {any} data
   */
  public add(data: any): any {
    const nonce = crypto.lib.WordArray.random(12).toString(crypto.enc.Base64);
    Object.assign(data, {nonce});
    return data;
  }
}
